import React from "react";
import PhoneInput from "react-phone-input-2";
import { Modal, Form, Button, Row } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import ImageUploading from "react-images-uploading";
import SelectField from "../GenericComponents/SelectField";
import TextField from "../GenericComponents/TextField";
import CustomRadioButton from "../GenericComponents/CustomRadioButton";
import styles from "./style";
import "./PatientContacts.css";
import "./uploadImage.css";
import CustomLoader from "../GenericComponents/CustomLoader";

const PORTAL_ACCESS_TYPES = ["FAMILY", "FRIEND", "CARE_GIVER"];

class NewContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  checkPhoneValidation = (value, country) => {
    //console.log("value...", value);
    //console.log("country...", country);

    if (value.match(/12345/)) {
      return "Invalid value: " + value + ", " + country.name;
    } else if (value.match(/1234/)) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const {
      showNewContactModal,
      contactTypes,
      formInputs,
      contactTypeParams,
      title,
      modalType,
      patientContactId,
      imageArr,
      loading,
      validated,
      isValidPhone,
      appModules,
      patientSubscription,
      handleSendInviteToggle,
      isEmailDisabled
    } = this.props;
    return (
      Object.keys(contactTypes).length !== 0 && (
        <div style={{ border: "none" }}>
          <CustomLoader loading={loading} />
          <Modal
            size="md"
            show={showNewContactModal}
            onHide={this.props.close}
            centered={true}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className={css(style.headerStyle)}>
              <Modal.Title className={css(style.titleStyle)}>
                {title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className={css(style.bodyStyle)}>
              <Row>
                <div style={{ textAlign: "end", fontSize: "14px", padding: "10px" }}>{"*required fields"}</div>
              </Row>
              <div>
                <Form
                  noValidate
                  autoComplete="off"
                  onSubmit={
                    modalType === 1
                      ? this.props.submitContactData
                      : this.props.updateContactData
                  }
                >
                  {contactTypeParams && contactTypeParams.enablePhotoOpt && (
                    <div style={{ padding: "2% 0", textAlign: "center" }}>
                      <ImageUploading
                        multiple={false}
                        value={formInputs.contactImage}
                        onChange={this.props.handleContactImage}
                        dataURLKey="path"
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            {imageList.length !== 0 ? (
                              imageList.map((image, index) => (
                                <div
                                  onClick={onImageUpdate}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    alt="avatar"
                                    title="update contact image"
                                    src={image["path"]}
                                    className={css(style.profile2)}
                                  />
                                </div>
                              ))
                            ) : (
                              <div
                                onClick={onImageUpload}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  alt="avatar"
                                  title="upload contact image"
                                  src={"/images/uploadIcon01.png"}
                                  className={css(style.profile1)}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  )}
                  <Form.Group className="mb-3" style={{ paddingTop: "1rem" }}>
                    <Form.Label className={css(styles.labels)}>
                      CONTACT TYPE*
                    </Form.Label>
                    <SelectField
                      name={"contactType"}
                      options={contactTypes}
                      value={formInputs.contactType}
                      defaultValue={formInputs.contactType}
                      action={this.props.handleChange}
                      className={"patient-input"}
                      required={true}
                    />
                  </Form.Group>
                  {contactTypeParams &&
                    contactTypeParams.enableNameOpt &&
                    contactTypeParams.splitName && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            {`FIRST NAME${contactTypeParams.fieldsValidation.firstName.required ? '*' : ""}`}
                          </Form.Label>
                          <TextField
                            type={"text"}
                            placeholder={"Enter your first name..."}
                            name={"firstName"}
                            value={formInputs.firstName}
                            action={this.props.handleChange}
                            isAlphaNumeric={true}
                            className={"patient-input"}
                            required={
                              contactTypeParams.fieldsValidation.firstName
                                .required
                            }
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            {`LAST NAME${contactTypeParams.fieldsValidation.lastName.required ? '*' : ""}`}
                          </Form.Label>
                          <TextField
                            type={"text"}
                            placeholder={"Enter your last name..."}
                            name={"lastName"}
                            value={formInputs.lastName}
                            action={this.props.handleChange}
                            isAlphaNumeric={true}
                            className={"patient-input"}
                            required={
                              contactTypeParams.fieldsValidation.lastName
                                .required
                            }
                          />
                        </Form.Group>
                      </>
                    )}
                  {contactTypeParams &&
                    contactTypeParams.enableNameOpt &&
                    !contactTypeParams.splitName && (
                      <Form.Group className="mb-3">
                        <Form.Label className={css(styles.labels)}>
                          {`${contactTypeParams.contactType} Name${contactTypeParams.fieldsValidation.firstName.required ? '*' : ""}`}
                        </Form.Label>
                        <TextField
                          type={"text"}
                          placeholder={`Enter your ${contactTypeParams.contactType} name...`}
                          name={"firstName"}
                          value={formInputs.firstName}
                          className={"patient-input"}
                          action={this.props.handleChange}
                          isAlphaNumeric={true}
                          required={
                            contactTypeParams.fieldsValidation.firstName
                              .required
                          }
                        />
                      </Form.Group>
                    )}
                  {contactTypeParams && contactTypeParams.enableEmailOpt && (
                    <Form.Group className="mb-3">
                      <Form.Label className={css(styles.labels)}>
                        {`EMAIL ADDRESS${contactTypeParams.fieldsValidation.email.required ? '*' : ""}`}
                      </Form.Label>
                      <TextField
                      style={{
                        backgroundColor: isEmailDisabled ? "#e9ecef" : "white",
                        color: isEmailDisabled ? "#6c757d" : "inherit",
                        cursor: isEmailDisabled ? "not-allowed" : "text",
                      }}
                        type={"email"}
                        placeholder={"Enter a secure email..."}
                        name={"email"}
                        value={formInputs.email}
                        className={"patient-input"}
                        action={this.props.handleChange}
                        required={
                          contactTypeParams.fieldsValidation.email.required
                        }
                        readOnly={PORTAL_ACCESS_TYPES.includes(contactTypeParams.code) && isEmailDisabled}
                      />
                    </Form.Group>
                  )}
                  <Form.Group className="mb-3">
                    <Form.Label className={css(styles.labels)}>
                      PHONE NUMBER*
                    </Form.Label>

                    <PhoneInput
                      isValid={(isValidPhone || formInputs.phone.length === 0) || contactTypeParams.allowEmergencyNumbers}
                      country={"us"}
                      placeholder={"Enter phone number..."}
                      value={formInputs.phone}
                      inputClass={"patient-phone-input"}
                      buttonClass={"phone-button-class"}
                      enableSearch={true}
                      onChange={(phone, country) => this.props.setPhoneNumber(phone, country)}
                      required={
                        Object.keys(contactTypeParams).length !== 0 &&
                        contactTypeParams.fieldsValidation.phoneNumber.required
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    {contactTypeParams &&
                      (contactTypeParams.enableEmergencyCallOpt ||
                        contactTypeParams.enableTextMessageOpt ||
                        contactTypeParams.enablePrescriptionMedsOpt ||
                        contactTypeParams.enableGeoFenceAlertOpt ||
                        contactTypeParams.enableBatteryStatusAlertOpt) && (
                        <div
                          style={{
                            textTransform: "uppercase",
                            fontSize: "14px",
                            fontWeight: "900",
                            padding: "5px 0px",
                          }}
                        >
                          {"For Help :"}
                        </div>
                      )}
                    <div className={css(styles.displayStyle)}>
                      {contactTypeParams &&
                        contactTypeParams.enableEmergencyCallOpt && (
                          <CustomRadioButton
                            type={"switch"}
                            inline={true}
                            label={"Call This Contact"}
                            checked={formInputs.enableEmergencyCallOpt}
                            action={this.props.handleEmergencyCall}
                          />
                        )}
                      {contactTypeParams &&
                        contactTypeParams.enableTextMessageOpt && (
                          <CustomRadioButton
                            type={"switch"}
                            inline={true}
                            label={"Send A Text Message"}
                            checked={formInputs.enableTextMessageOpt}
                            action={this.props.handleTextMessage}
                          />
                        )}
                      {contactTypeParams &&
                        contactTypeParams.enablePrescriptionMedsOpt && patientSubscription.subscriptionTier.code !== "SUBS_WM_GOLD_PLUS" && (
                          <CustomRadioButton
                            type={"switch"}
                            inline={true}
                            label={"Authorize To Receive Prescription Meds"}
                            checked={formInputs.enablePrescriptionMedsOpt}
                            action={this.props.handlePrescriptionMeds}
                          />
                        )}
                      {contactTypeParams &&
                        contactTypeParams.enableGeoFenceAlertOpt && appModules?.active?.GPS?.includes("GEO_LOCATION_TRACKING") && (
                          <CustomRadioButton
                            type={"switch"}
                            inline={true}
                            label={"Enable for Geo Fence Alerts"}
                            checked={formInputs.enableGeoFenceAlertOpt}
                            action={this.props.handleGeoFenceAlert}
                          />
                        )}
                      {contactTypeParams &&
                        contactTypeParams.enableBatteryStatusAlertOpt && (
                          <CustomRadioButton
                            type={"switch"}
                            inline={true}
                            label={"Enable for Low Battery Alerts"}
                            checked={formInputs.enableBatteryStatusAlertOpt}
                            action={this.props.handleBatteryPerAlert}
                          />
                        )}
                        {/* New Portal Invite Checkbox */}
                      {modalType === 1 && // Only for Add New Contact
                        contactTypeParams &&
                        PORTAL_ACCESS_TYPES.includes(contactTypeParams.code) && (
                          <>
                          <div
                          style={{
                            textTransform: "uppercase",
                            fontSize: "14px",
                            fontWeight: "900",
                            padding: "5px 0px",
                          }}
                        >
                          {"For Portal Access :"}
                        </div>
                          <CustomRadioButton
                            type={"checkbox"} // or "checkbox" based on your Generic Component
                            inline={true}
                            label={"Send Invite For Acuma Health User Portal Access (read-only access)"}
                            checked={formInputs.sendPortalInvite}
                            action={handleSendInviteToggle}
                          />
                          </>
                        )}
                    </div>
                  </Form.Group>

                  <div style={{ textAlign: "center", padding: "10px 5px 0px" }}>
                    <Button
                      variant="primary"
                      type="submit"
                      className={css(styles.buttonClass)}
                      disabled={(validated || !isValidPhone) && !contactTypeParams.allowEmergencyNumbers}
                    //style={{ marginRight: "10px" }}
                    >
                      {modalType === 1 ? "Submit" : "Update"}
                    </Button>
                  </div>
                </Form>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )
    );
  }
}

export default NewContactModal;

const style = StyleSheet.create({
  headerStyle: {
    //borderBottom: "0px",
    background: "#0d6cbf",
    padding: "10px 15px",
  },
  titleStyle: {
    fontSize: "18px",
    color: "white",
  },
  bodyStyle: {
    padding: "0px 16px 16px 16px",
  },
  profile1: {
    height: "90px",
    width: "90px",
  },
  profile2: {
    height: "90px",
    width: "90px",
    borderRadius: "50%",
  },
});
